import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UploadFileModel } from '../upload-file.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';

@Component({
    selector: 'abw-upload-file-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => UploadFileFormComponent),
        multi: true
      }
    ],
    templateUrl: './upload-file-form.component.html',
    styleUrls: ['./upload-file-form.component.scss']
})
export class UploadFileFormComponent extends AbstractWorkflowFormComponent<UploadFileModel, { filename: string, filecontent: any }> {
  filename: string = null;

  onFileUpload(e: any) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this, file.name);
      reader.readAsDataURL(file);
  }

  private _handleReaderLoaded(filename: string, event: any) {
      let reader = event.target;
      const base64Datas = reader.result.substr(reader.result.lastIndexOf(',') + 1);
      this.filename = filename;
      this.onValueChanged({ filename: filename, filecontent: base64Datas});
  }
}